// extracted by mini-css-extract-plugin
export default {"icon":"ui_icon__hWEJI"};